﻿import 'bootstrap';
import 'jquery';
import 'jquery-validation';
import 'jquery-validation-unobtrusive';
import 'kjua';
